import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
import { useRequestState } from "./useRequestState";
var CREATE_KEY = "postPlanCreationPlan";
var UPDATE_KEY = "patchPlanCreationPlan";
export var useSavePlan = function () {
    var dispatch = useDispatch();
    var create = useRequestState(CREATE_KEY);
    var update = useRequestState(UPDATE_KEY);
    var createPlan = function (body) {
        dispatch(customRequestApis({
            requestKey: CREATE_KEY,
            method: "POST",
            path: "/asg/Api/V1/Plan",
            body: { data: body },
        }));
    };
    var updatePlan = function (_a) {
        var id = _a.id, body = _a.body;
        dispatch(customRequestApis({
            requestKey: UPDATE_KEY,
            method: "PATCH",
            path: "/asg/Api/V1/Plan/".concat(id),
            body: { data: body },
        }));
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(CREATE_KEY));
            dispatch(clearCustomRequest(UPDATE_KEY));
        };
    }, []);
    return {
        createPlan: createPlan,
        updatePlan: updatePlan,
        createdPlan: create.data,
        updatedPlan: update.data,
        loadingCreate: create.loading,
        loadingUpdate: update.loading,
        errorCreate: create.error,
        errorUpdate: update.error,
        clearCreated: function () { return dispatch(clearCustomRequest(CREATE_KEY)); },
        clearUpdated: function () { return dispatch(clearCustomRequest(UPDATE_KEY)); },
    };
};
